import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

import { onMounted, ref, useTemplateRef, watch } from 'vue';
import { useResizeObserver } from '@vueuse/core';
import ModalWrapper from '@/shared/legacy/ui/modal-next/modal-wrapper.vue';
import AiBackground from '../ai-background/ai-background.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ai-modal',
  props: {
    open: { type: Boolean, default: true },
    transitionKey: {},
    size: { default: 'default' }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

// анимации исчезновения не работают


const emit = __emit;

function handleChange(flag) {
  if (!flag) {
    emit('close');
  }
}

// Height transition

const body = useTemplateRef('body');
const dynamicHeight = ref('');

onMounted(() => {
  setTimeout(() => {
    useResizeObserver(body.value, (entries) => {
      const entry = entries[0];
      const { height } = entry.contentRect;
      dynamicHeight.value = `${height}px`;
    });
  }, 500);
});

// Fade transition
const transitioning = ref(false);

watch(() => __props.transitionKey, () => {
  transitioning.value = true;
  setTimeout(() => {
    transitioning.value = false;
  }, 300);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalWrapper, {
    size: __props.size,
    open: __props.open,
    "modal-class": _ctx.$style.modal,
    "content-class": _ctx.$style.content,
    onChange: handleChange
  }, {
    before: _withCtx(() => [
      _createVNode(_Transition, {
        appear: "",
        "enter-from-class": _ctx.$style.transitionStart,
        "enter-active-class": _ctx.$style.transitionShow,
        "leave-active-class": _ctx.$style.transitionHide,
        "leave-to-class": _ctx.$style.transitionStart
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.background)
          }, [
            _createVNode(AiBackground)
          ], 2), [
            [_vShow, __props.open]
          ])
        ]),
        _: 1
      }, 8, ["enter-from-class", "enter-active-class", "leave-active-class", "leave-to-class"])
    ]),
    default: _withCtx(({ hide, dismiss, setDirty }) => [
      _createVNode(_Transition, {
        appear: "",
        "enter-from-class": _ctx.$style.transitionStart,
        "enter-active-class": _ctx.$style.transitionShow,
        "leave-active-class": _ctx.$style.transitionHide,
        "leave-to-class": _ctx.$style.transitionStart
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style.main, { [_ctx.$style.transition]: transitioning.value }]),
            style: _normalizeStyle({ height: dynamicHeight.value })
          }, [
            _createElementVNode("div", {
              ref_key: "body",
              ref: body,
              class: _normalizeClass(_ctx.$style.body)
            }, [
              _createVNode(_Transition, {
                "enter-from-class": _ctx.$style['delay-enter-from'],
                "enter-active-class": _ctx.$style['delay-enter-active'],
                "leave-active-class": _ctx.$style['delay-leave-active'],
                "leave-to-class": _ctx.$style['delay-leave-to'],
                mode: "out-in"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("div", {
                    key: `${__props.transitionKey}`
                  }, [
                    _renderSlot(_ctx.$slots, "default", {
                      transitioning: transitioning.value,
                      hide: hide,
                      dismiss: dismiss,
                      setDirty: setDirty
                    })
                  ]))
                ]),
                _: 2
              }, 1032, ["enter-from-class", "enter-active-class", "leave-active-class", "leave-to-class"])
            ], 2)
          ], 6)
        ]),
        _: 2
      }, 1032, ["enter-from-class", "enter-active-class", "leave-active-class", "leave-to-class"])
    ]),
    _: 3
  }, 8, ["size", "open", "modal-class", "content-class"]))
}
}

})